// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/planner_day.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";
import { file_studyo_today_planners_v1_resources_planner_day_annotation } from "./planner_day_annotation_pb.js";
import { file_studyo_today_planners_v1_resources_planner_item } from "./planner_item_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/planner_day.proto.
 */
export const file_studyo_today_planners_v1_resources_planner_day = /*@__PURE__*/
  fileDesc("CjRzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3BsYW5uZXJfZGF5LnByb3RvEiJzdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzItYCCgpQbGFubmVyRGF5Eh4KA2RheRgBIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSGAoQY3ljbGVfZGF5X251bWJlchgCIAEoBRIWCg5jeWNsZV9kYXlfbmFtZRgDIAEoCRJNCgthbm5vdGF0aW9ucxgEIAMoCzI4LnN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMuUGxhbm5lckRheUFubm90YXRpb24SPgoFaXRlbXMYBSADKAsyLy5zdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzLlBsYW5uZXJJdGVtEhsKE2xvbmdfY3ljbGVfZGF5X25hbWUYBiABKAkSJQodaXNfZGF5X29mX3dlZWtfY3ljbGVfZGF5X25hbWUYByABKAgSIwobY3ljbGVfZGF5X3NjaGVkdWxlX2N5Y2xlX2lkGAggASgJQiqqAidTdHVkeW8uVG9kYXkuUGxhbm5lcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_google_type_date, file_studyo_today_planners_v1_resources_planner_day_annotation, file_studyo_today_planners_v1_resources_planner_item]);

/**
 * Describes the message studyo.today.planners.v1.resources.PlannerDay.
 * Use `create(PlannerDaySchema)` to create a new message.
 */
export const PlannerDaySchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_planner_day, 0);

